module.exports = __webpack_public_path__ + "static/media/ecomerce@2x.0341071c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/ecomerce@2x.png
// module id = 84
// module chunks = 0